<template>
  <div class="header">
    <div class="header__inner">
      <h1 class="header__logo">
        <router-link to="/">
          <img src="@/assets/cia_logo_color.svg"
               alt="Centrum Innowacyjnej Archiwizacji">
        </router-link>
      </h1>
      <button
        @click="openMenu"
        role="button"
        class="header__hamburger hamburger hamburger--emphatic"
        :class="buttonClass"
        type="button">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      <ciaButton
        :title="'Zaloguj się'"
        class="header__accessability"
        :click="setBiggerFont"
      >
        A+
      </ciaButton>
      <div class="header__nav" :class="menuClass">
        <mainMenu @menu-clicked="openMenu"  />
        <div class="header__login">
          <ciaButton
            v-if="!token"
            :title="'Zaloguj się'"
            :click="goToLogin"
          >
            ZALOGUJ SIĘ
          </ciaButton>
          <ciaButton
            v-if="token"
            :title="'Dashboard'"
            :click="goToDashboard"
          >
            DASHBOARD
          </ciaButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ciaButton from './button.vue';
import mainMenu from './menu.vue';

export default {
  name: 'cia-header',
  components: {
    ciaButton,
    mainMenu,
  },
  data: () => ({
    menuVisibility: false,
  }),
  computed: {
    ...mapGetters('app', [
      'token',
    ]),
    menuClass() {
      return this.menuVisibility ? 'header__nav--active' : '';
    },
    buttonClass() {
      return this.menuVisibility ? 'is-active' : '';
    },
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToDashboard() {
      this.$router.push('/dashboard');
    },
    openMenu() {
      this.menuVisibility = !this.menuVisibility;
    },
    setBiggerFont() {
      const bodyClasses = document.body.classList;
      if (bodyClasses.contains('font-bigger')) {
        bodyClasses.remove('font-bigger');
      } else {
        bodyClasses.add('font-bigger');
      }
    },
  },
};
</script>
